import {
    OrganizationBrandingAsset,
    OrganizationBrandingAssetType
} from "../services/organization_branding.service";

const DEFAULT_BRANDING_URLS: Record<OrganizationBrandingAssetType, string> = {
    header_horizontal: "assets/images/logo/logo_icon_and_text_horizontal.png",
    header_icon: "assets/images/logo/logo_icon.png"
};

export const getDefaultOrganizationBrandingUrl = (assetType: OrganizationBrandingAssetType): string =>
    DEFAULT_BRANDING_URLS[assetType];

export const resolveOrganizationBrandingUrl = (
    assets: OrganizationBrandingAsset[],
    assetType: OrganizationBrandingAssetType
): string => assets.find((asset) => asset.assetType === assetType)?.url || getDefaultOrganizationBrandingUrl(assetType);
